var _dec, _dec2, _dec3, _class, _class2;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { layout as templateLayout } from '@ember-decorators/component';
import { observes } from '@ember-decorators/object';
import { action, computed } from '@ember/object';
import { A } from '@ember/array';
import { isPresent, isNone, isBlank } from '@ember/utils';
import FlyDropdown from '@customerio/fly-components/components/fly-dropdown';
import layout from '../templates/components/fly-dropdown-searchable';
import afterRender from '@customerio/fly-components/utils/after-render';
import itemProperty from '@customerio/fly-components/utils/item-property';
function matches(item, query, ...props) {
  let values = props.filter(isPresent).map(p => itemProperty(item, p));
  return values.some(v => (v || '').toString().toLowerCase().includes(query));
}

/**
  The fly-dropdown-searchable component works much like fly-dropdown, but with a
  search input at the top of the dropdown menu. This is used to filter the items
  by label, so that you can find what you're looking for, and select it.

  ```hbs
  <FlyDropdownSearchable
    \@items={{dogs}}
    \@selectedValue={{selectedValue}}
    \@prompt="Select a dog" />
  ```

  @class FlyDropdownSearchable
  @public
 */
let FlyDropdownSearchable = (_dec = templateLayout(layout), _dec2 = computed('items.[]', 'searchQuery'), _dec3 = observes('visibleItems.[]'), _dec(_class = (_class2 = class FlyDropdownSearchable extends FlyDropdown {
  constructor(...args) {
    super(...args);
    /**
      Optionally use a query param to autofill the search and also have it updated
      as the user searches.
       @attribute searchQuery
      @type string
     */
    _defineProperty(this, "searchQuery", '');
    /**
      Set the placeholder for the search input within the dropdown.
       @attribute searchPlaceholder
      @type string
     */
    _defineProperty(this, "searchPlaceholder", 'Search...');
    /**
      Additional properties in the data array to match against when searching.
       @attribute searchProperty
      @type array
     */
    _defineProperty(this, "searchProperty", null);
    /**
      Whether the dropdown element is currently disabled or not.
       @argument isDisabled
      @type boolean
     */
    _defineProperty(this, "isDisabled", false);
    /**
      Whether the field has an error associated to it. This is usually from
      validation, but could be from anything.
       @argument hasError
      @type boolean
     */
    _defineProperty(this, "hasError", false);
    /**
      The error message to display when an error has occured. The prescence of
      this attribute does not signal that an error has occured. For the error
      message to be visible, you must also set `hasError`.
       @argument errorMessage
      @type string
     */
    _defineProperty(this, "errorMessage", null);
    _defineProperty(this, "mainElement", null);
  }
  onInsert(element) {
    this.mainElement = element;
  }
  expand() {
    super.expand(...arguments);
    this.set('searchQuery', '');
    afterRender(() => this.mainElement.querySelector('.fly-dropdown-search-input input').focus());
  }
  get visibleItems() {
    let {
      items
    } = this;
    if (isNone(items)) {
      return A([]);
    }
    let query = this.searchQuery;
    if (isBlank(query)) {
      return A(items);
    }
    query = query.toLowerCase().trim();
    let label = this.labelProperty;
    let search = this.searchProperty;
    return A(items.filter(item => matches(item, query, label, search)));
  }
  _focusedItemObserver() {
    let items = this.visibleItems;
    let {
      selectedItem
    } = this;
    if (items.indexOf(selectedItem) !== -1) {
      this.set('focusedItem', selectedItem);
    } else {
      this.set('focusedItem', items[0]);
    }
  }
  didInsertToggle(toggleElement) {
    this.toggleElement = toggleElement;
  }
  collapse() {
    // TODO: This call to super is within an action, and has to refer to the parent
    // class's actions to be safe. This should be refactored to call a normal method
    // on the parent class. If the parent class has not been converted to native
    // classes, it may need to be refactored as well. See
    // https: //github.com/scalvert/ember-native-class-codemod/blob/master/README.md
    // for more details.
    super.actions.collapse.call(this, ...arguments);
    this.toggleElement.focus();
  }
  toggleSelection() {
    // TODO: This call to super is within an action, and has to refer to the parent
    // class's actions to be safe. This should be refactored to call a normal method
    // on the parent class. If the parent class has not been converted to native
    // classes, it may need to be refactored as well. See
    // https: //github.com/scalvert/ember-native-class-codemod/blob/master/README.md
    // for more details.
    super.actions.toggleSelection.call(this, ...arguments);
    this.toggleElement.focus();
  }
}, (_applyDecoratedDescriptor(_class2.prototype, "onInsert", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onInsert"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "visibleItems", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "visibleItems"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_focusedItemObserver", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "_focusedItemObserver"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "didInsertToggle", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "didInsertToggle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "collapse", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "collapse"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleSelection", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleSelection"), _class2.prototype)), _class2)) || _class);
export { FlyDropdownSearchable as default };